"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowNumericEditor_1 = require("../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../shared/components/editors/CardRowTextEditor");
var DlgFinanceManualOperation = /** @class */ (function (_super) {
    __extends(DlgFinanceManualOperation, _super);
    function DlgFinanceManualOperation(props) {
        return _super.call(this, props) || this;
    }
    DlgFinanceManualOperation.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.title,
                currencyTitle: data.currency_title,
                is_description_visible: data.show_description,
                is_tag_visible: data.show_tag,
                amount: data.amount
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            dialogTitle: this.props.controller.DATA.title,
            currencyTitle: this.props.controller.DATA.currency_title,
            amount: 100.00,
            description: "",
            tag: "",
            is_tag_visible: true,
            is_description_visible: true
        });
        this.doReSetRules();
    };
    DlgFinanceManualOperation.prototype.doReSetRules = function () {
        this.setState({
            amount_rules: { isError: false },
        });
    };
    DlgFinanceManualOperation.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgFinanceManualOperation.prototype.isDataValid = function () {
        this.doReSetRules();
        if (this.state.amount < 0) {
            this.setState({ amount_rules: { isError: true, errorMessage: "Поле [сумма] слишком мало!" } });
            return false;
        }
        if (isNaN(this.state.amount)) {
            this.setState({ amount_rules: { isError: true, errorMessage: "Поле [сумма] некорректно!" } });
            return false;
        }
        return true;
    };
    DlgFinanceManualOperation.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.amount, this.state.description, this.state.tag);
            }
        }
    };
    DlgFinanceManualOperation.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgFinanceManualOperation.prototype.OnAmountChanged = function (value) {
        this.setState({ amount: value });
    };
    DlgFinanceManualOperation.prototype.OnDescriptionChanged = function (newValue) {
        this.setState({ description: newValue });
    };
    DlgFinanceManualOperation.prototype.getDescriptionControl = function () {
        if (this.state.is_description_visible) {
            return (React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий операции", placeholder: "Введите комментарий" }, onValueChanged: this.OnDescriptionChanged.bind(this), value: this.state.description }));
        }
        else {
            return null;
        }
    };
    DlgFinanceManualOperation.prototype.OnTagChanged = function (newValue) {
        this.setState({ tag: newValue });
    };
    DlgFinanceManualOperation.prototype.getTagControl = function () {
        if (this.state.is_tag_visible) {
            return (React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг провайдера", placeholder: "Введите тэг провайдера" }, onValueChanged: this.OnTagChanged.bind(this), value: this.state.tag }));
        }
        else {
            return null;
        }
    };
    DlgFinanceManualOperation.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 700 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowTextEditor_1.default, { disabled: true, texts: { caption: "Валюта операции", placeholder: "Валюта операции" }, value: this.state.currencyTitle, onValueChanged: null }),
                React.createElement(CardRowNumericEditor_1.default, { onValueChanged: this.OnAmountChanged.bind(this), texts: { caption: "Сумма операции:", placeholder: "Введите сумму операции" }, values: { min: 0.00, max: 999999.99, value: this.state.amount }, precision: 2, step: 0.01 }),
                this.getDescriptionControl(),
                this.getTagControl()));
    };
    return DlgFinanceManualOperation;
}(React.Component));
exports.default = DlgFinanceManualOperation;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgFinanceManualOperation.tsx
// module id = 2046
// module chunks = 0